<!--
2022-08-17 Matt 推广员排行榜活动
-->
<template>
  <div class="affiliateActivityPage">
    <div class="nav-wrapper">
      <TopBack />
      <div class="nav">
        <div class="nav-item" :class="{active: activeTab==='rank'}" @click="activeTab = 'rank'">
          {{$t('lang.affiliate.rank')}}
        </div>
        <div class="nav-item" :class="{active: activeTab==='rules'}" @click="activeTab = 'rules'">
          {{$t('lang.affiliate.rules')}}
        </div>
      </div>
    </div>

    <div class="tab" v-show="activeTab==='rank'">
      <div class="rank-item">
        <div class="rank-no">
          <span>Rank</span>
        </div>
        <div class="rank-content" style="background: none">
          <div class="rank-username">
            <span>Nickname</span>
          </div>
          <div class="rank-splitter" style="border: none"></div>
          <div class="rank-referee-sum" style="text-align: center">
            <span style="margin: 0 auto">Score</span>
          </div>
          <div class="rank-reward" style="text-align: center">
            <span style="margin: 0 auto">Rewards</span>
          </div>
        </div>
      </div>
      <Loadmore
        :bottomPullText="$t('lang.loadingStatus.pullToLoad')"
        :bottomDropText="$t('lang.loadingStatus.releaseToLoad')"
        :bottomLoadingText="$t('lang.loadingStatus.loading')"
        :auto-fill="true"
        :bottom-method="getRanks"
        :bottom-all-loaded="hasLoadAll"
        ref="loadmore">
        <div class="ranks">
          <div v-for="(item, index) in ranks.slice(0, 50)" :key="index" class="rank-item">
            <div class="rank-no" :style="{backgroundImage: 'url(' + nobg + ')'}">
              <span>{{index+1}}</span>
            </div>
            <div class="rank-content">
              <div class="rank-username">
                <span>{{item.UserName}}</span>
              </div>

              <div class="rank-splitter"></div>

              <div class="rank-referee-sum">
                <div class="referee-sum">
                  <span>{{item.RefereeSum}}</span>
                </div>
              </div>

              <div class="rank-splitter"></div>

              <div class="rank-reward">
                <div class="referee-sum">
                  <span>{{item.Reward}}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="ranks.length === 0" class="no-data-available">
            {{$t('lang.bonus.noDataAvailable')}}
          </div>
        </div>
        <div class="showMore" v-if="!hasLoadAll"><img :src="showMore" alt=""></div>
      </Loadmore>

      <div class="rank-splitter"></div>

      <div class="rank-item" v-if="userInfo && userInfo.UserId">
        <div class="rank-no">
          <span>
            {{myRank && myRank.liveRank ? myRank.liveRank : '50+'}}
          </span>
        </div>
        <div class="rank-content">
          <div class="rank-username">
            <span>{{myRank ? myRank.UserName : userInfo.UserName}}</span>
          </div>
          <div class="rank-splitter"></div>
          <div class="rank-referee-sum">
            <div class="referee-sum">
              <span>{{myRank ? myRank.RefereeSum : '-'}}</span>
            </div>
          </div>
          <div class="rank-splitter"></div>
          <div class="rank-reward">
            <div class="referee-sum">
              <span>{{myRank ? myRank.Reward : 0}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tab rules" v-show="activeTab==='rules'" v-html="rulesHtml">
    </div>

    <div class="share-btn" @click="shareTo()" v-show="activeTab==='rank'">
      <img :src="inviteNow">
    </div>

    <Popup v-model="popupVisible" position="bottom">
      <div class="socialMedias">
        <img :src="facebook" alt="Facebook" @click="recordShareActivityEvent('facebook')">
        <img :src="telegram" alt="Telegram" @click="recordShareActivityEvent('telegram')">
        <img :src="whatsapp" alt="Whatsapp" @click="recordShareActivityEvent('whatsapp')">
      </div>
    </Popup>
  </div>
</template>

<script>
import {Loadmore, MessageBox, Popup} from 'mint-ui'
import request from '@/service'
import axios from 'axios'

import inviteNow from '@/assets/images/common/invite_now.png'
import whatsapp from '@/assets/images/common/whatsapp.svg'
import facebook from '@/assets/images/common/facebook.svg'
import telegram from '@/assets/images/common/telegram.svg'
import nobg from '@/assets/images/gamecompetition/nobg.png'
import showMore from '@/assets/images/common/showMore.gif'
import TopBack from '@/components/TopBack/index'

export default {
  name: 'AffiliateActivity',
  data () {
    return {
      showMore,
      nobg,
      inviteNow,
      whatsapp,
      facebook,
      telegram,
      activeTab: 'rank',
      accountInfo: {},
      userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
      facebookShareLink: '',
      telegramShareLink: '',
      whatsappShareLink: '',
      ranks: [],
      myRank: null,
      firstLoad: false,
      hasLoadAll: false,
      rulesHtml: '',
      popupVisible: false
    }
  },
  components: {
    TopBack,
    Loadmore,
    Popup
  },
  watch: {},
  mounted () {
    this.loadData()
    this.fetchAccount()
    this.getCurrentActivity()
    this.recordOpenPageEvent()
  },
  methods: {
    close () {},
    loadData: function () {
      const that = this
      let internation = ''
      if (localStorage.getItem('locale') === 'IN') {
        internation = 'IN'
      } else {
        internation = 'INT'
      }
      const url = location.origin + '/static/startupPopup-' + internation + '.json'
      axios.get(url).then(res => {
        if (res.data != null) {
          this.startupPopupConfig = res.data
          let languagePre = this.$store.state.locale
          languagePre = languagePre === 'EN' ? '' : '-' + languagePre
          const htmlFileURL = location.origin + '/static/promotionRules/AffiliateActivity-' + this.$store.state.internation + languagePre + '.html'
          axios.get(htmlFileURL).then(res => {
            if (res.data != null) {
              that.rulesHtml = res.data
            }
          })
        }
      })
    },
    getCurrentActivity () {
      const internation = this.$store.state.internation || 'IN'
      request('get', `/innovation/activity/affiliate-current?internation=${internation}`)
        .then(activity => {
          const startAt = new Date(activity.StartAt)
          const endAt = new Date(activity.EndAt)
          const now = new Date()

          if (now < startAt) {
            MessageBox.confirm(
              this.$t('lang.affiliate.activityNotStartYetMessageContent'),
              this.$t('lang.affiliate.activityNotStartYetMessageTitle'),
              {
                closeOnClickModal: true,
                showCancelButton: false,
                confirmButtonText: this.$t('lang.affiliate.confirmButtonText')
              })
          } else if (now > endAt) {
            MessageBox.confirm(
              this.$t('lang.affiliate.activityEndedMessageContent'),
              this.$t('lang.affiliate.activityEndedMessageTitle'),
              {
                closeOnClickModal: true,
                showCancelButton: false,
                confirmButtonText: this.$t('lang.affiliate.confirmButtonText')
              })
          }
        })
    },
    getRanks () {
      const internation = this.$store.state.internation || 'IN'
      request('get', `/innovation/activity/affiliate-ranks?internation=${internation}`)
        .then(ranks => {
          this.ranks = ranks
          this.hasLoadAll = true

          if (this.userInfo && this.userInfo.userId) {
            for (const [rank, index] of ranks.entries()) {
              if (rank.UserUniqueId === this.userInfo.userId) {
                this.myRank = rank
                const liveRank = index + 1
                if (liveRank <= 50) {
                  this.myRank.liveRank = liveRank
                } else {
                  this.myRank.liveRank = '50+'
                }
                break
              }
            }
          }
        })
    },
    shareTo: function () {
      this.popupVisible = true
    },
    fetchAccount () {
      if (this.userInfo) {
        const url = '/innovation/account/getuseraccount'
        const data = {
          userId: this.userInfo.UserId
        }
        request('post', url, data).then(res => {
          this.accountInfo = res
          const message = this.$t(
            'lang.affiliate.welcomeMessage', {
              downloadURL: encodeURIComponent(res.InviteLink),
              shareCode: res.ShareCode
            })
          this.whatsappShareLink = `whatsapp://send?text=${message}`
          this.telegramShareLink = `https://t.me/share/url?url=${message}`
          this.facebookShareLink = `fb://faceweb/f?href=https://m.facebook.com/sharer.php?u=${this.accountInfo.InviteLink}`
        }).catch(err => {
          console.log(err)
        })
      }
    },
    recordOpenPageEvent () {
      if (this.userInfo) {
        const url = '/innovation/activity/event'
        const internation = this.$store.state.internation || 'IN'
        const data = {
          userId: this.userInfo.UserId,
          category: 'OPEN_PAGE',
          internation
        }
        request('post', url, data)
          .catch(err => {
            console.log(err)
          })
      }
    },
    recordShareActivityEvent (shareTo) {
      if (this.userInfo) {
        const that = this
        const url = '/innovation/activity/event'
        const internation = this.$store.state.internation || 'IN'
        const data = {
          userId: this.userInfo.UserId,
          internation,
          category: 'SHARE_ACTIVITY',
          shareCode: this.accountInfo.ShareCode,
          shareTo
        }
        request('post', url, data)
          .then(() => {
            if (shareTo === 'facebook') {
              window.open(that.facebookShareLink, '_blank')
            } else if (shareTo === 'telegram') {
              window.open(this.telegramShareLink, '_blank')
            } else if (shareTo === 'whatsapp') {
              window.open(this.whatsappShareLink, '_blank')
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .affiliateActivityPage {
    padding-top: 50px;

    .nav-wrapper {
      display: flex;
      flex-direction: column;

      .nav {
        display: flex;
        margin: 24px 10px 20px 10px;
        border-radius: 6px;
        border: 1px solid rgba(246, 217, 170, 0.5);

        .nav-item {
          flex: 1;
          line-height: 30px;
          text-align: center;
        }

        .active {
          background: #F6D9AA;
          color: #543200;
          border-radius: 6px;
        }
      }
    }

    .ranks {
      height: 52vh;
      overflow: scroll;
    }
    @media (max-width: 380px) {
      .ranks {
        height: 44vh;
        overflow: scroll;
      }
    }

    .no-data-available {
      line-height: 100px;
      text-align: center;
    }

    .rank-item {
      margin: 5px 10px;
      display: flex;
      line-height: 25px;

      .rank-no {
        width: 25px;
        height: 25px;
        background-size: contain;
        text-align: center;
        color: #FFFFFF;
      }

      .rank-content {
        background: rgba(237, 185, 5, 0.2);
        margin: 0 0 0 20px;
        width: calc(100vw - 20px - 25px - 20px);
        border-radius: 52px;
        display: flex;

        .rank-username {
          width: calc(100vw - 20px - 25px - 20px - 150px - 1px);
          padding: 0 15px;
          color: #FFFFFF;
          font-size: 14px;
          word-break:keep-all; // 不换行
          white-space:nowrap; // 不换行
          overflow:hidden; // 内容超出宽度时隐藏超出部分的内容
          text-overflow:ellipsis; // 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用 2022-08005 HHY 增加
          text-align: center;
        }

        .rank-splitter {
          width: 1px;
          border-right: 1px solid #F6D9AA;
          margin: 3px 0px;
        }

        .rank-referee-sum {
          width: 100px;
          text-align: center;
          color: #FFFFFF;
          font-size: 14px;
          display: flex;

          .referee-sum{
            width: 100%;
            text-align: center;
          }
        }
        .rank-reward {
          width: 100px;
          text-align: center;
          color: #FFFFFF;
          font-size: 14px;
          display: flex;

          .referee-sum{
            width: 100%;
            text-align: center;
          }
        }
      }
    }

    .rank-splitter {
      margin: 15px 10px 15px 10px;
      border-bottom: 1px solid #FFFFFF;
    }

    .rules{
      margin: 0px 10px 0px 10px;
      height: 68vh;
      overflow: scroll;
    }
    @media (max-width: 380px) {
      .rules {
        height: 65vh;
        overflow: scroll;
      }
    }

    .share-btn{
      display: flex;
      justify-content: center;
      img {
        width: 55vw;
        height: 6vh;
        margin-top: 10px;
      }
    }

    .socialMedias {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      width: 100vw;
      height: 18vh;
      padding: 20px;
      background: #2F2F2F;

      img {
        width: 32px
      }
    }

    .showMore {
      text-align: center;
      img {
        width: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/AffiliateActivity/index.vue